module.exports = __webpack_public_path__ + "img/28-ArubaConnect.11620305.jpg";